import React from 'react';
import './MediaGrid.css';

const MediaGrid = ({ media, onMediaClick }) => {
  if (!media || media.length === 0) {
    return <div className="empty-state"><p>No media found for this year.</p></div>;
  }

  return (
    <div className="media-grid-container">
      <div className="gallery-grid">
        {media.map((item, index) => (
          <div
            key={index}
            className="gallery-item"
            onClick={() => onMediaClick(item)}
          >
            {item.isVideo ? (
              <video>
                <source src={item.url} type="video/mp4" />
              </video>
            ) : item.isDocument ? (
              <div className="document-placeholder">
                <div className="document-icon">📄</div>
                <div className="document-name">{item.name}</div>
              </div>
            ) : (
              <img src={item.url} alt={item.name} loading="lazy" />
            )}
            <div className="gallery-overlay">
              <div className="gallery-label">
                <span className="gallery-type">{item.type}</span>
                <span className="gallery-date">{item.date}</span>
                {item.time && <span className="gallery-date">{item.time}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MediaGrid;